export default "__VITE_ASSET__Ddg0gGJD__"